import { skipToken } from "@tanstack/react-query";
import useCurrentProjectId from "@v2/hooks/useCurrentProjectId";
import { v2CustomDomainRouter } from "@v2/trpc/routes/v2CustomDomain";

const useDefaultV2CustomDomain = () => {
  const projectId = useCurrentProjectId();

  const { data: customDomainData } =
    v2CustomDomainRouter.getByProjectId.useQuery(
      projectId ? { projectId } : skipToken,
    );

  const defaultCustomDomain = customDomainData?.customDomains.find(
    (domain) => !domain.isPending,
  );

  return defaultCustomDomain;
};

export default useDefaultV2CustomDomain;
